import countries from '../assets/countries.json';
import {
  CLASS_DROPDOWN_PHONE_BUTTON,
  CLASS_PHONE_DROPDOWN_OPEN,
  CLASS_PHONE_DROPDOWN_OPTION_ITEM,
  CLASS_PHONE_DROPDOWN_OPTION_ITEM_HIGHLIGHT,
  CLASS_PHONE_DROPDOWN_OPTION_ITEM_SELECTED,
  SELECTOR_DROPDOWN_PHONE_BUTTON,
  SELECTOR_PHONE_DROPDOWN_OPTION_ITEM,
  SELECTOR_PHONE_DROPDOWN_OPTION_LIST,
  SELECTOR_PHONE_INPUT,
  SELECTOR_PHONE_SELECTED_FLAG,
  SELECTOR_SEARCH_COUNTRY,
} from '../constants';

export const phoneDropdown = {
  countries,
  searchQuery: '',

  async init(context, containerElement, dropdownElement) {
    if (!dropdownElement) return;

    this.context = context;
    this.dropdownElement = dropdownElement;
    this.containerElement = containerElement;
    this.selectedOption = containerElement.querySelector(SELECTOR_DROPDOWN_PHONE_BUTTON);
    this.optionList = dropdownElement.querySelector(SELECTOR_PHONE_DROPDOWN_OPTION_LIST);
    this.phoneInput = containerElement.querySelector(SELECTOR_PHONE_INPUT);
    this.searchInput = dropdownElement.querySelector(SELECTOR_SEARCH_COUNTRY);
    this.selectedFlag = containerElement.querySelector(SELECTOR_PHONE_SELECTED_FLAG);

    this.bindEvents();
    this.renderCountryList(this.countries);
    this.setDefaultOption();
  },

  handleSearch(e) {
    if (!this.dropdownElement.classList.contains(CLASS_PHONE_DROPDOWN_OPEN)) return;

    if (!this.lastSearchTime || Date.now() - this.lastSearchTime > 1000) {
      this.searchQuery = '';
    }

    this.lastSearchTime = Date.now();

    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
      this.searchQuery += e.key.toLowerCase();
    } else if (e.key === 'Backspace') {
      this.searchQuery = this.searchQuery.slice(0, -1);
    }
    const query = this.searchQuery.trim().toLowerCase();

    const startsWithMatch = this.countries.filter((country) => {
      return (
        country.name.toLowerCase().startsWith(query) ||
        country.dialCode.replace(/\D/g, '').startsWith(query)
      );
    });

    const includesMatch = this.countries.filter((country) => {
      return (
        !startsWithMatch.includes(country) &&
        (country.name.toLowerCase().includes(query) ||
          country.dialCode.replace(/\D/g, '').includes(query))
      );
    });

    const filteredCountries = [...startsWithMatch, ...includesMatch];

    this.renderCountryList(this.classList);

    if (filteredCountries.length > 0) {
      this.highlightBestMatch(filteredCountries[0]);
    }
  },

  highlightBestMatch(country) {
    const countryOptions = this.optionList.querySelectorAll(`.${CLASS_PHONE_DROPDOWN_OPTION_ITEM}`);

    countryOptions.forEach((option) => {
      option.classList.remove(CLASS_PHONE_DROPDOWN_OPTION_ITEM_HIGHLIGHT);

      const countryName = option
        .querySelector('.boost-sd__bis-country-name')
        .textContent.toLowerCase();

      if (countryName === country.name.toLowerCase()) {
        option.classList.add(CLASS_PHONE_DROPDOWN_OPTION_ITEM_HIGHLIGHT);
        option.scrollIntoView({ behavior: 'instant', block: 'center' });
      }
    });
  },

  renderCountryList(countries = this.countries) {
    this.optionList.innerHTML = '';
    countries.forEach((country) => {
      const option = document.createElement('div');
      option.classList.add(CLASS_PHONE_DROPDOWN_OPTION_ITEM);
      option.setAttribute('tabindex', '0');
      option.innerHTML = `
        <img src="${country.flag}" alt="${country.name}" class="boost-sd__bis-country-flag">
        <span class="boost-sd__bis-country-name">${country.name}</span>
        <span class="boost-sd__bis-country-code">${country.dialCode}</span>
      `;

      if (this.selectedCountry && country.name === this.selectedCountry.name) {
        option.classList.add(CLASS_PHONE_DROPDOWN_OPTION_ITEM_SELECTED);
      }

      option.addEventListener('click', () => this.selectCountry(country));
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          this.selectCountry(country);
        }
      });
      this.optionList.appendChild(option);
    });

    if (this.optionList.scrollHeight > this.optionList.clientHeight) {
      this.optionList.style.overflowY = 'auto';
    }
  },

  setDefaultOption() {
    if (this.countries.length > 0) {
      this.selectCountry(this.countries[0]);
    }
  },

  selectCountry(country) {
    this.selectedCountry = country;
    this.selectedFlag.src = country.flag;
    this.selectedFlag.alt = country.name;
    this.phoneInput.placeholder = `(${country.dialCode}) XXX-XXXX`;

    const allOptions = this.optionList.querySelectorAll(SELECTOR_PHONE_DROPDOWN_OPTION_ITEM);
    allOptions.forEach((option) =>
      option.classList.remove(CLASS_PHONE_DROPDOWN_OPTION_ITEM_SELECTED)
    );

    const selectedOption = Array.from(allOptions).find(
      (option) =>
        option.querySelector('.boost-sd__bis-country-name').textContent.toLowerCase() ===
        country.name.toLowerCase()
    );
    if (selectedOption) {
      selectedOption.classList.add(CLASS_PHONE_DROPDOWN_OPTION_ITEM_SELECTED);
    }

    this.toggleDropdown(false);
    this.phoneInput.focus();
  },

  toggleDropdown(forceOpen = null) {
    const isExpanded = this.dropdownElement.getAttribute('aria-expanded') === 'true';
    const shouldExpand = forceOpen !== null ? forceOpen : !isExpanded;

    this.dropdownElement.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
    this.dropdownElement.classList.toggle(CLASS_PHONE_DROPDOWN_OPEN, shouldExpand);
    this.selectedOption.classList.toggle(CLASS_DROPDOWN_PHONE_BUTTON, shouldExpand);
  },

  bindEvents() {
    if (this.selectedOption) {
      this.selectedOption.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggleDropdown();
      });
    }

    document.addEventListener('click', (event) => {
      if (
        !this.dropdownElement.contains(event.target) &&
        !this.selectedOption.contains(event.target)
      ) {
        this.toggleDropdown(false);
      }
    });

    this.selectedOption.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Enter') {
        this.toggleDropdown(true);
        this.searchInput.focus();
      }
    });

    this.searchInput.addEventListener('input', (e) => {
      this.searchQuery = '';
      this.handleSearch(e);
    });

    document.addEventListener('keydown', (e) => this.handleSearch(e));
  },

  handleClickOutside(event) {
    if (
      !this.dropdownElement.contains(event.target) &&
      !this.selectedOption.contains(event.target)
    ) {
      this.toggleDropdown(false);
    }
  },
};
